import { Component, OnInit, Input, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { ProductosService } from '../../../../services/productos.service';
import { ConstantsService } from '../../../../services/constants.service';

@Component({
  selector: 'app-modal-seleccion-productos',
  templateUrl: './modal-seleccion-productos.component.html',
  styleUrls: ['./modal-seleccion-productos.component.scss']
})
export class ModalSeleccionProductosComponent implements OnInit {
    @Output() productosSeleccionados: EventEmitter<any> = new EventEmitter;
    @Input() public tipoServicio: string = null;
    @ViewChild('content') private content: TemplateRef<any>;

    //Modelos
    public productos: any[] = [];

    //helpers
    public id_tipo_servicio: number = null;
    public modal: any = null;
    public cuentasPorPagar: any [] = [];
    public loading: boolean = false;
    public palabra_clave: string = null;
    public api_url:string = '';

    constructor(private modalService: NgbModal,
        private productosService: ProductosService,
        private constantsService: ConstantsService) { 
        this.api_url = constantsService.apiURL;
    }

    ngOnInit() {
    }

    private cargarProductos(){
        this.loading = true;
        let filtros = { 
            id_tipo_servicio: this.id_tipo_servicio,
            palabra_clave: this.palabra_clave
        };

        this.productosService.listarProductos(filtros)
        .subscribe(
            (response)=> {
                this.loading = false;
                let content = response.json().content;
                this.productos = content;            
            },
            (error) => {
            this.loading = false;
            }
        );
      }
    
    public openModal(id_tipo_servicio: number) {
        this.id_tipo_servicio = id_tipo_servicio;
        this.palabra_clave = null;

        this.cargarProductos();

        this.modal = this.modalService.open(this.content, { size: 'lg' });
    }

    public seleccionarProducto(producto){
        this.productosSeleccionados.emit(producto);
        this.closeModal();       
    }

    public closeModal() {
        this.modal.close();
    }
}


// WEBPACK FOOTER //
// ./src/app/components/modulo-servicios/formulario-servicio-general/modal-seleccion-productos/modal-seleccion-productos.component.ts